import SimpleLightbox from "simplelightbox";

let lbs = 0;

export class Lightbox {

  constructor(container) {
    this.container = container;
    if (!this.container.id) {
      this.container.id = 'lb' + (lbs++);
    }
    this.init();
  }

  init() {
    this.lightbox = new SimpleLightbox('#' + this.container.id + ' a', {
      animationSpeed: 150
    });
  }

}
